import React from "react";
import { Row, Col, Card } from "antd";
import plane from "../../assests/images/planeicon.svg";
import truck from "../../assests/images/SVG/packetSurface.svg";
import "../FirstMile/style.scss";

const RatesCardView = ({ rateData }) => {
  if (!rateData.rate) return;
  const renderCards = (services, mode) => {
    const colSpan = Object.keys(services).length === 2 ? 12 : 8;

    return Object.entries(services).map(([category, details]) => (
      <Col key={`${mode}-${category}`} span={colSpan}>
        <Card
          title={
            <span
              className={
                {
                  standard: "blue",
                  fastTrack: "green",
                  valuePlus: "orange",
                }[category] || ""
              }
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </span>
          }
          style={{
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            borderRadius: "5px",
          }}
          className={
            {
              standard: "border-blue rates-card-blue",
              fastTrack: "border-green rates-card-green",
              valuePlus: "border-orange rates-card-orange",
            }[category] || ""
          }
        >
          {details?.odaCharges ? (
            <>
              <p>
                Base :{" "}
                <span style={{ fontSize: "14px" }}>
                  <span style={{ fontWeight: "500" }}>
                    ₹ {details.baseRate}
                  </span>
                </span>
              </p>
              <p>
                ODA: &nbsp;&nbsp;
                <span style={{ fontSize: "14px" }}>
                  <span style={{ fontWeight: "500" }}>
                    ₹ {details.odaCharges}
                  </span>
                </span>
              </p>

              <p>
                Total: &nbsp;
                <span style={{ fontSize: "14px" }}>
                  <span style={{ fontWeight: "500" }}>₹ {details.total}</span>
                </span>
              </p>
            </>
          ) : (
            <p>
              Total:{" "}
              <span style={{ fontSize: "14px" }}>
                <span style={{ fontWeight: "500" }}>₹ {details.total}</span>
              </span>
            </p>
          )}
        </Card>
      </Col>
    ));
  };

  const styles = {
    standard: {
      background: "#ffffff",
      border: "1px solid #77b6f0",
      boxShadow: "inset 0px 0px 11px #a9c6e1",
      borderRadius: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
    },

    fastTrack: {
      background: "#ffffff",
      border: "1px solid #f8d47a",
      boxShadow: "inset 0px 0px 11px #f1deac",
      borderRadius: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "5px",
    },
  };
  return (
    <div>
      {Object.entries(rateData?.rate?.dox || {}).length > 0 ? (
        <Row gutter={24}>
          {/* Air Rates */}
          <Col span={12}>
            <h3 style={styles.fastTrack}>
              {" "}
              <img src={plane} alt={"Air"} style={{ marginRight: 8 }} />
              Air Rates
            </h3>
            <Row gutter={24} className="mt-1">
              {rateData?.rate?.dox?.air &&
                renderCards(rateData?.rate?.dox.air, "air")}
            </Row>
          </Col>

          {/* Surface Rates */}
          <Col span={12}>
            <h3 style={styles.standard}>
              {" "}
              <img src={truck} alt={"Surface"} style={{ marginRight: 8 }} />
              Surface Rates
            </h3>
            <Row gutter={16} className="mt-1">
              {rateData?.rate?.dox?.surface &&
                renderCards(rateData?.rate?.dox.surface, "surface")}
            </Row>
          </Col>
        </Row>
      ) : (
        <Row gutter={16}>
          {/* Air Rates */}
          <Col span={12}>
            <h3 style={styles.fastTrack}>
              {" "}
              <img src={plane} alt={"Air"} style={{ marginRight: 8 }} />
              Air Rates
            </h3>
            <Row gutter={16}>
              {rateData?.rate?.nonDox?.air &&
                renderCards(rateData?.rate?.nonDox.air, "air")}
            </Row>
          </Col>

          {/* Surface Rates */}
          <Col span={12}>
            <h3 style={styles.standard}>
              {" "}
              <img src={truck} alt={"Surface"} style={{ marginRight: 8 }} />
              Surface Rates
            </h3>
            <Row gutter={16}>
              {rateData?.rate?.nonDox?.surface &&
                renderCards(rateData?.rate?.nonDox.surface, "surface")}
            </Row>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default RatesCardView;
